import * as T from 'three';

export function seeded(seed) {
  return () => { seed = (Math.imul(seed, 1664525) + 1013904223) >>> 0; return seed / 4294967296; };
}
export const pathX = z => Math.sin(z / 51) * 12 + Math.sin(z / 93) * 9;
export function ground(x, z) {
  const bank = Math.max(0, Math.abs(x - pathX(z)) - 32);
  return -z * .095 + Math.sin(z * .035) * 1.0 + Math.sin(x * .032) * .7 + Math.min(22, bank * bank * .007);
}

function pineGeometry() {
  const positions=[], colors=[]; const rng=seeded(714);
  const green=new T.Color('#416569'), dark=new T.Color('#284b54'), snow=new T.Color('#e2eff0');
  function tri(a,b,c,color) { for(const p of [a,b,c]) { positions.push(...p); colors.push(color.r,color.g,color.b); } }
  for(let layer=0;layer<7;layer++) {
    const y=.8+layer*.57, size=(1-layer/8)*1.25;
    for(let branch=0;branch<7;branch++) {
      const a=branch/7*Math.PI*2+layer*.53, len=size*(.85+rng()*.28);
      const point=(r,ang,h)=>[Math.cos(ang)*r,h,Math.sin(ang)*r];
      const root=point(.10,a,y+.34), tip=point(len,a,y-.23);
      const left=point(len*.68,a-.34,y-.06), right=point(len*.68,a+.34,y-.06);
      const bottom=point(len*.55,a,y-.20), crest=point(len*.46,a,y+.17);
      tri(root,left,crest,green);tri(root,crest,right,green);
      tri(left,tip,crest,snow);tri(tip,right,crest,snow);
      tri(left,bottom,tip,dark);tri(tip,bottom,right,dark);
      tri(root,bottom,left,dark);tri(root,right,bottom,dark);
    }
  }
  const geo=new T.BufferGeometry();geo.setAttribute('position',new T.Float32BufferAttribute(positions,3));geo.setAttribute('color',new T.Float32BufferAttribute(colors,3));geo.computeVertexNormals();return geo;
}

export function createEnvironment(scene) {
  const rng=seeded(95316);const far=[];const scenery=new T.Group();scene.add(scenery);
  const groundGeo=new T.BufferGeometry();const positions=[],colors=[],uv=[],indices=[];
  const nx=140,nz=180; const snow=new T.Color('#e7eeea'), shadow=new T.Color('#b6ced9');
  for(let j=0;j<=nz;j++)for(let i=0;i<=nx;i++) {
    const x=-210+i*3,z=-100+j*3;
    positions.push(x,ground(x,z),z);uv.push(x*.025,z*.025);
    const bank=Math.min(1,Math.abs(x-pathX(z))/60);
    const c=snow.clone().lerp(shadow,bank*.20+Math.max(0,Math.sin(x*.4+z*.18))*.018);
    colors.push(c.r,c.g,c.b);
    if(i<nx&&j<nz) { const a=j*(nx+1)+i;indices.push(a,a+nx+1,a+1,a+1,a+nx+1,a+nx+2); }
  }
  groundGeo.setAttribute('position',new T.Float32BufferAttribute(positions,3));groundGeo.setAttribute('color',new T.Float32BufferAttribute(colors,3));groundGeo.setAttribute('uv',new T.Float32BufferAttribute(uv,2));groundGeo.setIndex(indices);groundGeo.computeVertexNormals();
  const groundMat=new T.MeshStandardMaterial({color:'#fffefa',vertexColors:true,roughness:.94});
  const texSize=256,normalData=new Uint8Array(texSize*texSize*4);
  for(let y=0;y<texSize;y++)for(let x=0;x<texSize;x++){const i=(y*texSize+x)*4;normalData[i]=128+Math.round(Math.sin(x*.7)*7+(rng()-.5)*12);normalData[i+1]=128+Math.round((rng()-.5)*14);normalData[i+2]=255;normalData[i+3]=255;}
  const normalTex=new T.DataTexture(normalData,texSize,texSize,T.RGBAFormat);normalTex.wrapS=normalTex.wrapT=T.RepeatWrapping;normalTex.magFilter=T.LinearFilter;normalTex.minFilter=T.LinearFilter;normalTex.repeat.set(18,18);normalTex.needsUpdate=true;groundMat.normalMap=normalTex;groundMat.normalScale.set(.20,.20);
  const land=new T.Mesh(groundGeo,groundMat);land.receiveShadow=true;scenery.add(land);

  const treeCount=142,dummy=new T.Object3D();
  const trees=new T.InstancedMesh(pineGeometry(),new T.MeshStandardMaterial({vertexColors:true,roughness:1,flatShading:true}),treeCount);
  const trunks=new T.InstancedMesh(new T.CylinderGeometry(.075,.13,2.0,7),new T.MeshStandardMaterial({color:'#526163',roughness:1}),treeCount);
  trees.castShadow=true;trees.receiveShadow=true;trunks.castShadow=true;
  for(let i=0;i<treeCount;i++) {
    const z=-24+rng()*290,side=i%2?1:-1;
    const x=pathX(z)+side*(35+rng()*35),scale=.85+rng()*1.0;
    dummy.position.set(x,ground(x,z),z);dummy.rotation.set(0,rng()*Math.PI*2,0);dummy.scale.setScalar(scale);dummy.updateMatrix();trees.setMatrixAt(i,dummy.matrix);
    dummy.position.y+=scale*.72;dummy.updateMatrix();trunks.setMatrixAt(i,dummy.matrix);
  }
  scenery.add(trees,trunks);

  for(let i=0;i<22;i++) {
    const x=(i%2?1:-1)*(36+rng()*25),z=-12+rng()*230;
    const geo=new T.DodecahedronGeometry(.9+rng()*1.7,0);
    const rock=new T.Mesh(geo,new T.MeshStandardMaterial({color:i%2?'#738997':'#a9bcc3',roughness:1,flatShading:true}));
    rock.position.set(x,ground(x,z)-.35,z);rock.scale.set(1,.7,1.2);rock.rotation.y=rng()*5;rock.castShadow=true;rock.receiveShadow=true;scenery.add(rock);
    const cap=rock.clone();cap.geometry=geo;cap.material=new T.MeshStandardMaterial({color:'#e4eeee',roughness:1,flatShading:true});cap.scale.multiplyScalar(.92);cap.scale.y*=.52;cap.position.y+=.59;scenery.add(cap);
  }

  // Layered, asymmetric ridgelines; every mountain sits beyond the preview slope.
  for(let layer=0;layer<3;layer++) {
    const n=58,m=25,ps=[],cs=[],ids=[];
    const distance=450+layer*180;
    const rockColor=new T.Color(['#6e8b9f','#8fabc0','#aec5d5'][layer]);
    const peakColor=new T.Color(['#e0ebed','#d9e6ed','#d5e3ed'][layer]);
    for(let j=0;j<=m;j++)for(let i=0;i<=n;i++) {
      const x=-650+i*1300/n,z=distance+j*8;
      const ridge=100+80*Math.sin(x*.013+layer*.7)**2+65*Math.sin(x*.023-1.5)**6;
      const y=-75+ridge*Math.sin((j/m)*Math.PI*.78)+11*Math.sin(x*.11+z*.032)*Math.sin(j/m*Math.PI);
      ps.push(x,y,z);
      const c=rockColor.clone().lerp(peakColor,Math.min(1,Math.max(0,(y-13)/40+Math.sin(x*.017)*.25)));
      cs.push(c.r,c.g,c.b);
      if(i<n&&j<m){const a=j*(n+1)+i;ids.push(a,a+n+1,a+1,a+1,a+n+1,a+n+2);}
    }
    const geo=new T.BufferGeometry();geo.setAttribute('position',new T.Float32BufferAttribute(ps,3));geo.setAttribute('color',new T.Float32BufferAttribute(cs,3));geo.setIndex(ids);geo.computeVertexNormals();
    const mountain=new T.Mesh(geo,new T.MeshBasicMaterial({vertexColors:true,side:T.DoubleSide,fog:false}));far.push(mountain);scene.add(mountain);
    const reverse=mountain.clone();reverse.rotation.y=Math.PI;reverse.position.y+=25;scene.add(reverse);
  }
  const skyMat=new T.ShaderMaterial({side:T.BackSide,depthWrite:false,uniforms:{top:{value:new T.Color('#5c9fc5')},bottom:{value:new T.Color('#dbe7ed')}},vertexShader:'varying vec3 vPosition; void main(){vPosition=position; gl_Position=projectionMatrix*modelViewMatrix*vec4(position,1.);}',fragmentShader:'uniform vec3 top; uniform vec3 bottom; varying vec3 vPosition; void main(){float h=clamp(normalize(vPosition).y*.95+.12,0.,1.);gl_FragColor=vec4(mix(bottom,top,pow(h,.65)),1.); #include <tonemapping_fragment>\n #include <colorspace_fragment>\n}'});
  // Shader directives must begin on their own line.
  skyMat.fragmentShader=skyMat.fragmentShader.replace('; #include',';\n#include');
  const sky=new T.Mesh(new T.SphereGeometry(1400,32,20),skyMat);sky.renderOrder=-10;scene.add(sky);
  scene.fog=new T.Fog('#dae8ec',180,650);
  const hemi=new T.HemisphereLight('#dcefff','#91a5b7',2.0);scene.add(hemi);
  const sun=new T.DirectionalLight('#fff4db',3.1);sun.position.set(-12,24,14);sun.castShadow=true;
  sun.shadow.mapSize.set(2048,2048);sun.shadow.camera.left=-13;sun.shadow.camera.right=13;sun.shadow.camera.top=13;sun.shadow.camera.bottom=-13;sun.shadow.camera.near=1;sun.shadow.camera.far=70;sun.shadow.normalBias=.018;sun.shadow.bias=-.00015;
  scene.add(sun,sun.target);

  // A quiet trail marker gives the foreground a readable scale.
  for(const s of [-1,1]) {
    const pole=new T.Mesh(new T.CylinderGeometry(.035,.045,1.05,8),new T.MeshStandardMaterial({color:'#324c59',roughness:.8}));
    const x=s*6,z=10;pole.position.set(x,ground(x,z)+.525,z);pole.castShadow=true;scenery.add(pole);
    const marker=new T.Mesh(new T.BoxGeometry(.42,.23,.035),new T.MeshStandardMaterial({color:s<0?'#48b8ac':'#f07861',roughness:.8}));marker.position.copy(pole.position);marker.position.y+=.32;marker.rotation.y=s*.1;marker.castShadow=true;scenery.add(marker);
  }
  let lightMode='day';
  return { groundMat, sun, hemi, dispose(){normalTex.dispose();},
    setLight(mode) {
      lightMode=mode;
      const dusk=mode==='dusk';
      sun.color.set(dusk?'#ffc591':'#fff4db');sun.intensity=dusk?2.6:3.1;
      hemi.color.set(dusk?'#c6c7e8':'#dcefff');hemi.groundColor.set(dusk?'#7384a5':'#91a5b7');hemi.intensity=dusk?1.8:2.0;
      skyMat.uniforms.top.value.set(dusk?'#697ba8':'#5c9fc5');skyMat.uniforms.bottom.value.set(dusk?'#f4c8ba':'#dbe7ed');scene.fog.color.set(dusk?'#cfcbd9':'#dae8ec');
      far.forEach((m,i)=>m.material.color.set(dusk?['#dbb7c7','#c4b9d3','#d6cbdf'][i]:'#ffffff'));
    },
    follow(position) {
      sun.target.position.copy(position);sun.position.copy(position).add(new T.Vector3(-12,lightMode==='dusk'?15:24,14));
      sky.position.set(position.x,0,position.z);
    }
  };
}
